module.exports = __webpack_public_path__ + "static/img/background.ede80f76.svg";